declare namespace $ {

	type $giper_baza_flex_field__pawn_giper_baza_flex_form_1 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_form['field_pawn'] >
		,
		ReturnType< $giper_baza_flex_field['pawn'] >
	>
	type $giper_baza_flex_field__prop_giper_baza_flex_form_2 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_form['field_prop'] >
		,
		ReturnType< $giper_baza_flex_field['prop'] >
	>
	type $giper_baza_flex_field__enabled_giper_baza_flex_form_3 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_form['enabled'] >
		,
		ReturnType< $giper_baza_flex_field['enabled'] >
	>
	type $mol_view__sub_giper_baza_flex_form_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_expander__title_giper_baza_flex_form_5 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_form['field_name'] >
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__expanded_giper_baza_flex_form_6 = $mol_type_enforce<
		ReturnType< $giper_baza_flex_form['field_expanded'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__content_giper_baza_flex_form_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	export class $giper_baza_flex_form extends $mol_list {
		field_name( id: any): string
		field_expanded( id: any, next?: boolean ): boolean
		field_pawn( id: any, next?: $giper_baza_pawn ): $giper_baza_pawn
		field_prop( id: any): $giper_baza_flex_prop
		enabled( ): boolean
		Field_control( id: any): $giper_baza_flex_field
		Field_content( id: any): $mol_view
		Field( id: any): $mol_expander
		fields( ): readonly(any)[]
		pawn( ): $giper_baza_dict
		meta( ): $giper_baza_flex_meta
		rows( ): ReturnType< $giper_baza_flex_form['fields'] >
	}
	
}

//# sourceMappingURL=form.view.tree.d.ts.map